module.exports = __webpack_public_path__ + "static/img/IMG_20150307_162842.2ccdcc24.jpg";